import React, {useState, useContext, useCallback} from 'react';
import {Text, Icon, Button, Anchor} from '@albert-io/atomic';

import FeatureFlag from 'client/components/FeatureFlag/FeatureFlag.react';

import {useTracking} from 'react-tracking';

import {ContentDiscoveryContext} from '../ContentDiscoveryProvider.react';

import ErrorBoundary from '../SubjectAndGuideSelector/TopicsModal/ErrorBoundary.react';

import StandardsModal, {StandardsModalFallback} from './StandardsModal/StandardsModal.react';

const StandardSelector = () => {
  const [showModal, setShowModal] = useState(false);
  const {trackEvent} = useTracking({content: 'standard', event: 'click', type: 'button'});
  const {clearStandardsModal, hasSelectedStandard} = useContext(ContentDiscoveryContext);

  const clearHandler = useCallback(() => {
    clearStandardsModal();
    trackEvent({content: 'clear standards'});
  }, [trackEvent, clearStandardsModal]);

  return (
    <div>
      <div className='filter-label'>
        <Text size='s' className='u-flex-grow_1'>
          Standards
        </Text>
        {hasSelectedStandard() && (
          <Anchor
            tabIndex={0}
            className='a-text--size-s u-mar-r_2'
            onClick={clearHandler}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                clearHandler();
              }
            }}
          >
            Clear
          </Anchor>
        )}
        <Button
          size='s'
          variant='outlined'
          data-testid='assignment-builder__add-standards-btn'
          onClick={() => {
            setShowModal(true);
            trackEvent({content: 'standard'});
          }}
          className='u-mar-l_auto'
        >
          Add
          <Icon icon={['far', 'circle-plus']} className='u-mar-l_1' />
        </Button>
      </div>
      <ErrorBoundary>
        {showModal && (
          <FeatureFlag name='content_personalization'>
            <StandardsModal handleClose={() => setShowModal(false)} />
            <FeatureFlag.Fallback>
              <StandardsModalFallback handleClose={() => setShowModal(false)} />
            </FeatureFlag.Fallback>
          </FeatureFlag>
        )}
      </ErrorBoundary>
    </div>
  );
};

export default StandardSelector;
